import { WS_CODE } from '@/types/apiTypes';

export const formatPercentage = (value: number): string => {
    if (typeof value !== 'number' || isNaN(value)) {
        return '-';
    }

    if (value % 1 === 0) {
        return `${value.toFixed(0)}%`;
    }
    return `${value.toFixed(2)}%`;
};
export const getWS_Code = () => {
    return sessionStorage.getItem(WS_CODE) || '';
};
